import accountApi from '@/xhr/services/account'

// 菜单是来源于路由菜单 ，保留主要为了权限路由准备
const state = {
  // 菜单
  menuPar: [
    {
      name: '工作流',
      icon: 'icon-shouye1',
      basePath: '/dash',
      menuList: [
        {
          name: '任务中心',
          url: '/dash/tasks',
        },
        {
          name: '流程查询',
          url: '/dash/tasksSearch',
        },
      ],
    },
    {
      name: '房源管理',
      icon: 'icon-fangyuanguanli',
      basePath: '/house',

      menuList: [
        {
          name: '我的房源',
          url: '/house/myHouse',
        },
        {
          name: '房东合同',
          url: '/house/trusteeship',
        },
        {
          name: '空调数据',
          url: '/house/fee',
        },
        {
          name: '房价配置',
          url: '/house/housePrice',
        },
        {
          name: '能耗费配置',
          url: '/house/energy',
        },
        {
          name: '设备配置',
          url: '/house/equipment',
        },
        {
          name: '营销规则',
          url: '/house/market',
        },
        {
          name: '建信导入',
          url: '/house/jx-export',
        },
        {
          name: '账单批量导入',
          url: '/house/online-export',
        },
      ],
    },
    {
      name: '租赁管理',
      icon: 'icon-zulinguanli',
      basePath: '/rent',

      menuList: [
        {
          name: '出租管理',
          url: '/rent/lease',
        },
        // {
        //   name: '预约看房',
        //   url: '/rent/rent1',
        // },
        {
          name: '预定房源',
          url: '/rent/reserveHouse',
        },
        {
          name: '退租管理',
          url: '/rent/cancelRent',
        },
        {
          name: '续租管理',
          url: '/rent/renew',
        },
        {
          name: '换房管理',
          url: '/rent/changeHouse',
        },
        {
          name: '转租管理',
          url: '/rent/sublet',
        },
        {
          name: '租客合同',
          url: '/rent/contract',
        },
        {
          name: '企业信息',
          url: '/rent/enterprise-list',
        },
        {
          name: '企业出租',
          url: '/rent/enterprise-contract',
        },
      ],
    },
    {
      name: '账单管理',
      icon: 'icon-zhangdan',
      basePath: '/pay',

      menuList: [
        {
          name: '应收账单',
          url: '/pay/receivables',
        },
        {
          name: '应付账单',
          url: '/pay/bills',
        },
      ],
    },
    // {
    //      name: '售后管理',
    //     icon: 'icon-shouhouguanli',
    //     basePath: '/service',
    //     menuList: [
    //     {name: '维修管理',
    //     url: '/service/repair',
    //     },
    //     {name: '保洁管理',
    //     url: '/service/clean',
    //     },

    //     ]
    //     },
    {
      name: '报表',
      icon: 'icon-baobiao1',
      basePath: '/report',
      menuList: JSON.parse(localStorage.getItem('menuList'))
      // menuList: [
        // {
        //   name: '新出房业绩',
        //   url: '/report/newReport',
        // },
        // {
        //   name: '续租报表',
        //   url: '/report/relet',
        // },
        // {
        //   name: '房态数据报表',
        //   url: '/report/roomStatus',
        // },
        // {
        //   name: '业务运营报表',
        //   url: '/report/business',
        // },
        // {
        //   name: '投资数据报表',
        //   url: '/report/invest',
        // },
        // {
        //   name: '片区房态数据',
        //   url: '/report/houseStatus',
        // },
        // {
        //   name: '财务公司房态',
        //   url: '/report/companyHouseStatus',
        // },
        // {
        //   name: '片区间夜出租率',
        //   url: '/report/unitOvernightRentalRate',
        // },
        // {
        //   name: '财务公司间夜出租率',
        //   url: '/report/companyOvernightRentalRate',
        // },
        // {
        //   name: '片区新签间数',
        //   url: '/report/unitNewSign',
        // }, {
        //   name: '片区退租间数',
        //   url: '/report/unitLease',
        // }, {
        //   name: '财务公司退租间数',
        //   url: '/report/companyLease',
        // }, {
        //   name: '片区签约间数',
        //   url: '/report/unitSigned',
        // }, {
        //   name: '财务公司签约间数',
        //   url: '/report/companySigned',
        // },
      // ],
    },
    {
      name: '摊销管理',
      icon: 'icon-caiwu',
      basePath: '/amortize',
      menuList: [
        {
          name: '摊销报表',
          url: '/amortize/index',
        },
        {
          name: '支出摊销状态',
          url: '/amortize/expendingStatus',
        },
        {
          name: '收支情况表',
          url: '/amortize/situation',
        },
      ],
    },
    {
      name: '绩效',
      icon: 'icon-jixiaoguanli',
      basePath: '/mangerPerformance',
      menuList: [
        {
          name: '管家管理',
          url: '/mangerPerformance/manage',
        },
        {
          name: '管家绩效',
          url: '/mangerPerformance/performance',
        }, {
          name: '管家绩效(新)',
          url: '/mangerPerformance/housekeeperMonth'
        }, {
          name: '签约绩效',
          url: '/mangerPerformance/tenantsBusiness'
        },
        {
          name: '投资绩效',
          url: '/mangerPerformance/investmentPerformance'
        }
      ],
    },
    {
      name: '权限管理',
      icon: 'icon-quanxian',
      basePath: '/privilegeManagement',
      menuList: [
        {
          name: '员工管理',
          url: '/privilegeManagement/staff',
        },
        {
          name: '角色管理',
          url: '/privilegeManagement/role',
        },
      ],
    },
  ],
  get reportMenu() {
    // console.log('ssssss')
    return JSON.parse(localStorage.getItem('menuList')) || []
  }
}

const mutations = {
  // 更换报表目录
  changeReportMenu(state, data) {
    state.menuPar.forEach(item => {
      if (item.name === '报表') {
        item.menuList = data || []
      }
    })
    localStorage.setItem('menuList', JSON.stringify(data))
  },
}

const actions = {
  // 获取报表目录
  async getReportMenu(context, userId) {
    let reportMenu = await accountApi.getMenuList(userId)
    if (reportMenu.data.code !== 200) {
      localStorage.setItem('menuList', JSON.stringify([]))
      return false
    }
    let { data } = reportMenu.data
    context.commit('changeReportMenu', data)
  }
}

export default {
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js